// extracted by mini-css-extract-plugin
export default {"item-list":"BeersDesktop_item-list__C-TT9","item":"BeersDesktop_item__XyWkD","section":"BeersDesktop_section__qBaK8"};